<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_business">
    <p class="detailedsearch_tit">
      業種
    </p>

    <ul class="detailedsearch_list">
      <li v-for="item in businessTypesStore.master" :key="item.code">
        <label :for="`business_types_${item.code}`">
          <input type="checkbox"
                v-model="checkboxValue"
                :id="`business_types_${item.code}`"
                :value="item.code">
          <span>{{ item.text }}</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const businessTypesStore = inject('businessTypesStore')
const checkboxValue = computed({
  get: () => businessTypesStore.businessTypes.value,
  set: (value) => businessTypesStore.set(value)
})
</script>
